<template>
<div>
	<div class="row">

		<div class="col-12">
			<partial-loader :loading="isFetching"></partial-loader>
		</div>

		<div class="col-12"
		     v-if="!isFetching">

			<h2 class="display-4">Aankoop kosten</h2>

			<p>
				Aantal kavels: {{ costs.item_count }}
			</p>

			<b-alert v-if="error"
					variant="danger"
					show>{{ error }}</b-alert>

			<b-alert v-if="formError"
					show
					variant="warning">
				<span v-for="(errors, i) in formError.errors" :key="i">
					<span v-for="(error, j) in errors" :key="`${i}-${j}`">{{ error }}<br /></span>
				</span>
			</b-alert>

			<b-form @submit.prevent="save">

				<div class="row mb-2">
					<div class="col">{{ $t('buyerCost.buyerTotal') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              class="text-right"
							              disabled
							              :value="Number(costs.item_cost).toFixed(2)"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('buyerCost.commission') }} <small>({{ Number(costs.commission_percentage).toFixed(2) }}%)</small></div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              class="text-right"
							              disabled
							              :value="Number(costs.commission).toFixed(2)"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('buyerCost.fixedCommissionPercentage') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-percentage fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              class="text-right"
							              step="any"
										  autocomplete="off"
							              v-model="form.fixed_commission_percentage"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('buyerCost.tableMoney') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              class="text-right"
							              disabled
										  autocomplete="off"
							              :value="Number(costs.table_money).toFixed(2)"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">Verzendkosten</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="form.shipping_cost"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">Administratiekosten</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="form.administration_cost"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">Korting</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="form.discount"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<hr />

				<div class="row mb-2">
					<div class="col">
						<h5>Factuurbedrag</h5>
					</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<h5 class="text-right">{{ costs.total_cost | currency }}</h5>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">
						<h5>Betaald</h5>
					</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<h5 class="text-right">{{ costs.total_paid | currency }}</h5>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">
						<h5>Openstaand</h5>
					</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<h5 class="text-right">{{ costs.remaining_cost | currency }}</h5>
					</div>
				</div>

				<b-btn class="pull-right"
				       type="submit"
				       variant="primary"
				       v-b-tooltip.hover
				       title="Opslaan"><i class="fa fa-fw fa-save"></i>
				</b-btn>

			</b-form>
		</div>

		<div class="col-sm-12" v-if="!isFetching">
			<hr class="my-4" />
			<h3 class="display-4">{{ $t('common.payments') }}</h3>

			<b-table v-if="!isFetching"

				striped
				hover
				show-empty
				:items="costs.payments"
				:fields="paymentList.fields"
				:per-page="5"
				:sort-by.sync="paymentList.sortBy"
				:sort-desc.sync="paymentList.sortDesc"
				:busy="isFetching"
				:empty-text="$t('payment.listEmptyText')">

				<template v-slot:cell(type)="row">
					<span v-if="row.item.type">{{ $t(`payment.${row.item.type}`) }}</span>
				</template>

				<template v-slot:cell(amount)="row">
					<span v-if="row.item.amount">{{ `€ ${row.item.amount.replace('.', ',')}` }}</span>
				</template>

				<template v-slot:cell(date)="row">
					<span v-if="row.item.date">{{ convertDate(row.item.date) }}</span>
				</template>

				<template v-slot:cell(actions)="row">
					<b-button-group class="pull-right">
						<b-btn variant="outline-danger" @click="showDeleteModal(row.item)"><i class="fa fa-fw fa-trash"></i></b-btn>
					</b-button-group>
				</template>

			</b-table>

			<h4 class="mt-4">{{ $t('payment.addPayment') }}</h4>

			<b-form @submit.prevent="createPayment">
				<div class="row mb-2">
					<div class="col">Type</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<multiselect
							v-model="paymentForm.selectedType"
							label="label"
							:options="paymentForm.types"
							:show-labels="false"
							:searchable="false">
						</multiselect>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">Bedrag</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="paymentForm.amount"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">Datum</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-calendar-alt fa-fw"></i></b-input-group-prepend>
							<datepicker
								v-model="paymentForm.date"
								:format="convertDate"
								input-class="text-right form-control date-field"
							>
							</datepicker>
						</b-input-group>
					</div>
				</div>

				<b-btn class="pull-right"
				       type="submit"
				       variant="primary"
				       v-b-tooltip.hover
				       title="Opslaan"><i class="fa fa-fw fa-save"></i>
				</b-btn>
			</b-form>

			<delete-dialog-modal ref="deleteModal"
				:delete-name="paymentList.selectedDeleteName"
				:item="paymentList.selectedDeletePayment"
				:isDeleting="paymentList.isDeleting"
				@confirm="deletePayment">
			</delete-dialog-modal>
		</div>

		<div class="col-sm-12"
		     v-if="!isFetching">
			<hr class="my-4" />
			<h3 class="display-4">{{ $t('common.invoice') }}</h3>

			<b-form v-if="costs.person"
			        @submit.prevent="downloadInvoice">

				<div class="row">
					<div class="col-md-6">
						<b-form-group :label="$t('common.date')">
							<b-form-input type="date"
										  autocomplete="off"
							              v-model="invoiceForm.date">
							</b-form-input>
						</b-form-group>

						<b-form-group :label="$t('common.invoiceType')">
							<multiselect
								v-model="invoiceForm.type"
								placeholder="Select one"
								label="text"
								:showLabels="false"
								:options="invoiceTypes"
								:searchable="false"
								:multiple="false">
							</multiselect>
						</b-form-group>
					</div>

					<div class="col-md-6">
						<b-form-group :label="$t('buyerCost.note')">
							<b-form-textarea v-model="invoiceForm.note"
							                 :rows="3"
							                 :max-rows="6">
							</b-form-textarea>
						</b-form-group>
					</div>

					<div class="col-12">
						<b-btn-group class="pull-right">
							<b-btn variant="primary"
							       v-b-tooltip.hover
							       v-bind:disabled="isEmailing"
							       @click="emailInvoiceModal"
							       :title="$t('common.emailInvoice')">
								<fa-icon icon="envelope"
								         fixed-width />
							</b-btn>
							<loader-button variant="primary"
								v-b-tooltip.hover
								type="submit"
								:title="$t('common.downloadReport')"
								iconName="file-pdf"
								:loading="isDownloading"
							/>
						</b-btn-group>
					</div>

					<modal ref="emailModal"
					       size="lg"
					       :title="`${$t('common.emailInvoice')}`">

						<div slot="modal-body">
							<div class="row">
								<div class="col">
									<b-form-textarea v-model="invoiceForm.email_text"
									                 :rows="6"
									                 :max-rows="6">
									</b-form-textarea>
								</div>
							</div>
						</div>
						<div slot="modal-footer">
							<div class="row">
								<div class="col">
									<b-button class="mt-3"
									          type="button"
									          variant="outline-primary"
									          block
									          @click="cancelEmailInvoiceModal">{{ $t('common.cancel') }}</b-button>
								</div>
								<div class="col">
									<b-button class="mt-3"
									          type="button"
									          v-bind:disabled="isEmailing"
									          block
									          variant="primary"
									          @click="emailInvoice">

										<loader-spinner :text="$t('common.emailInvoice')"
										                :show-spinner="isEmailing"></loader-spinner>

									</b-button>
								</div>
							</div>
						</div>
					</modal>
				</div>

			</b-form>

			<p v-else>
				{{ $t('buyer.noPersonInvoice') }}
			</p>
		</div>

		<div class="col-sm-12" v-if="!isFetching">
			<hr class="my-4" />
			<h3 class="display-4">{{ $t('common.emailLogs') }}</h3>

			<email-logs-component
				:isFetching="isFetching"
				:logs="costs.email_logs"
			/>
		</div>
	</div>

</div>
</template>

<script>
import { isNil, pick, keys, forEach } from 'lodash';
import BidNumberService from '@/services/bid-number-service.js';
import PaymentService from '@/services/payment-service.js';
import InvoiceService from '@/services/invoice-service.js';
import PartialLoader from '@/components/elements/PartialLoader';
import Datepicker from 'vuejs-datepicker';
import { flashSuccess, flashDanger } from '@/helpers/flash-message-helper';
import { isCancel, CancelToken } from 'axios';
import { currency } from '@/filters/number-filter';
import moment from 'moment';
import { smallDate, formatDate } from '@/filters/date-filters';
import Modal from '@/components/elements/Base/BaseDialogModal';
import LoaderSpinner from '@/components/elements/LoaderSpinner';
import DeleteDialogModal from '@/components/elements/Edit/DeleteDialogModal';
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import EmailLogsComponent from '../../../elements/EmailLogsComponent';

export default {
	components: {
		PartialLoader,
		EmailLogsComponent,
		Modal,
		LoaderSpinner,
		DeleteDialogModal,
		Datepicker,
		Multiselect
	},
	filters: {
		currency,
		smallDate
	},
	data() {
		return {
			isFetching: true,
			isEmailing: false,
			isDownloading: false,
			costs: false,
			form: {
				fixed_commission_percentage: null,
				administration_cost: '',
				shipping_cost: '',
				discount: '',
			},
			invoiceForm: false,
			invoiceTypes: [
				{ value: 'unpaid', text: 'Niet betaalde goederen' },
				{ value: 'paid', text: 'Betaalde goederen' },
				{ value: 'overview', text: 'Alle goederen' }
			],
			paymentList: {
				fields: [
					{ key: 'type', label: this.$t('payment.type') },
					{ key: 'amount', label: this.$t('payment.amount') },
					{ key: 'date', label: this.$t('payment.date') },
					{ key: 'actions', label: this.$t('common.actions'), class: 'text-right' },
				],
				sortBy: 'created_at',
				sortDesc: true,
				selectedDeleteName: null,
				selectedDeletePayment: null,
				isDeleting: false,
				error: '',
			},
			paymentForm: false,
			paymentFormTypes: [
        { label: this.$t('payment.pin'), value: 'pin' },
        { label: this.$t('payment.cash'), value: 'cash' },
				{ label: this.$t('payment.transfer'), value: 'transfer' }
			],
			error: false,
			formError: false
		}
	},
	computed: {
		...mapGetters([
			'activeAuction'
		])
	},
	watch: {
		activeAuction() {
			this.init();
		},
		costs() {
			this.form.fixed_commission_percentage = (this.costs.fixed_commission_percentage !== null) ? this.costs.fixed_commission_percentage : Number(30).toFixed(4);
			this.form.shipping_cost = Number(this.costs.shipping_cost).toFixed(2);
			this.form.administration_cost = Number(this.costs.administration_cost).toFixed(2);
			this.form.discount = Number(this.costs.discount).toFixed(2);
		}
	},
	methods: {
		fetchData() {
			this.error = false;
			this.isFetching = true;

			return BidNumberService.getBidNumberCost(this.$route.params.auctionId, this.$route.params.bidNumber).then(response => {
				this.isFetching = false;
        this.costs = response;

			}).catch(error => {
				if (!isCancel(error)) {
					this.isFetching = false;
					this.error = error.message;
				}
			});
		},
		save(event) {
			this.formError = false;
			this.isFetching = true;
			const post = this.form;

			return BidNumberService.updateBidNumberCost(this.$route.params.auctionId, this.$route.params.bidNumber, post).then(response => {
				this.fetchData().then(() => flashSuccess(this.$t('buyerCost.updateSuccess')));
			}).catch(error => {
				this.isFetching = false;
				this.formError = error.response.data;
			});
		},
		async downloadInvoice() {
			const params = this.invoiceForm;
			params.type = this.invoiceForm.type.value
			this.isDownloading = true;

			try {
				const response = await InvoiceService.getBidNumberInvoiceUrl(this.$route.params.auctionId, this.$route.params.bidNumber, params);

				const data = window.URL.createObjectURL(response);
				const dateString = `${(new Date()).toLocaleDateString('nl', { year:'numeric', month:'numeric', day:'numeric' })}`
				let aTag = document.createElement('a');

				aTag.href = data;
				aTag.download = `Factuur ODB ${dateString}.pdf`;
				aTag.style = "position: absolute; opacity: 0;";
				aTag.target = '_blank';

				document.body.appendChild(aTag);
				aTag.click();

				this.isDownloading = false;

				setTimeout(function () {
					document.body.removeChild(aTag);
					window.URL.revokeObjectURL(data);
				}, 100);
			}
			catch (error) {
				this.isDownloading = false;
				throw error;
			}

			this.initInvoiceForm();
		},
		emailInvoiceModal() {
			this.$refs.emailModal.show();
			return false;
		},
		cancelEmailInvoiceModal() {
			this.invoiceForm.email_text = this.activeAuction.buyer_invoice_email_text;
			this.$refs.emailModal.hide();
		},
		emailInvoice() {
			this.isEmailing = true;
			const params = this.invoiceForm;
			params.email = 1;
			params.type = this.invoiceForm.type.value

			InvoiceService.emailBidNumberInvoice(this.$route.params.auctionId, this.$route.params.bidNumber, params)
				.then(response => {
					flashSuccess(this.$t('common.emailSend'));
					this.isEmailing = false;
					this.initInvoiceForm();
					this.cancelEmailInvoiceModal();
				}).catch(error => {
					this.isEmailing = false;
					this.formError = error.response.data;
				});
		},
		initInvoiceForm() {
			this.invoiceForm = {
				date: moment().format('YYYY-MM-DD'),
				note: '',
				type: this.invoiceTypes[0],
				email_text: this.activeAuction.buyer_invoice_email_text
			};
		},
		init() {
			this.fetchData();
			this.initPaymentForm();
			this.initInvoiceForm();
		},
		convertDate(date) {
			let dateOptions = { year:'numeric', month:'short', day:'numeric' };
			let d = new Date(date);

			return `${d.toLocaleDateString('nl', dateOptions)}`
		},

		/**
		 * Show delete modal for the payment
		 * @param {Object} payment
		 */
		showDeleteModal(payment) {
			this.paymentList.selectedDeletePayment = payment;
			this.paymentList.selectedDeleteName	   = `de betaling van € ${payment.amount.replace('.', ',')}`;
			this.$refs.deleteModal.show();
		},

		/**
		 * Delete payment
		 *
		 * @param {Object} payment
		 */
		deletePayment(payment) {

			this.paymentList.isDeleting = true;

			return PaymentService.delete(payment.id)
				.then(
					response => {
						this.$refs.deleteModal.hide();
						this.paymentList.isDeleting = false;
						flashSuccess('Betaling verwijderd');
						this.fetchData();
					}
				)
				.catch(
					error => {
						this.$refs.deleteModal.hide();
						this.paymentList.isDeleting = false;
						this.paymentList.error = error.message;
					}
				);
		},
		createPayment() {
			this.isFetching = true;
			const post = this.form;

			let params = {
				buyer_costs_id: this.costs.buyer_costs_id,
				type: this.paymentForm.selectedType.value,
				amount: this.paymentForm.amount,
				date: moment(this.paymentForm.date).format('YYYY-MM-DD')
			};

			if (params.buyer_costs_id == null) {
				return BidNumberService.updateBidNumberCost(this.$route.params.auctionId, this.$route.params.bidNumber, post)
					.then(response => {
						params.buyer_costs_id = response.buyer_costs_id;

						return PaymentService.create(params)
							.then(response => {
								flashSuccess('Betaling toegevoegd');
								this.initPaymentForm();
								this.fetchData();
							})
							.catch(error => {
								this.isFetching = false;
								this.paymentForm.error = error.message;
								flashDanger(this.paymentForm.error);
							});
					})
					.catch(error => {
						this.isFetching = false;
						this.formError = error.response.data;
					});
			}
			else {
				return PaymentService.create(params)
					.then(response => {
						flashSuccess('Betaling toegevoegd');
						this.initPaymentForm();
						this.fetchData();
					})
					.catch(error => {
						this.isFetching = false;
						this.paymentForm.error = error.message;
						flashDanger(this.paymentForm.error);
					});
			}
		},
		initPaymentForm() {
			this.paymentForm = {
				types: this.paymentFormTypes,
				selectedType: this.paymentFormTypes[0],
				amount: Number(0).toFixed(2),
				date: new Date(),
				error: '',
			}
		},
	},
	mounted() {

	}
}
</script>

<style lang="scss">
.date-field {
	background: white !important;
	width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// BidNumberCost.vue?1f44c9c6